// 캐리어 전용 포탈 — 본인 배차 수신 + 운송 상태 업데이트 + 배차표 다운로드 (배차 D3, 2026-06-02)
//   백엔드: routes/carrierPortal.js (GET /carrier/me, /carrier/dispatches, /:id, /:id/xlsx, PATCH /:id/status)
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

var NAVY = '#1B3A5C';
var ST_COLOR = { '전달': '#2563eb', '운송중': '#ea580c', '완료': '#16a34a' };

function CarrierPortal({ showToast, user }) {
  var st = showToast || function () {};
  var meState = useState(null); var me = meState[0]; var setMe = meState[1];
  var listState = useState([]); var list = listState[0]; var setList = listState[1];
  var detailState = useState(null); var detail = detailState[0]; var setDetail = detailState[1];

  function loadMe() { authFetch(API + '/carrier/me').then(function (r) { return r.json(); }).then(function (d) { if (d && d.success) setMe(d); }).catch(function () {}); }
  function loadList() { authFetch(API + '/carrier/dispatches').then(function (r) { return r.json(); }).then(function (d) { if (d && d.success) setList(d.items || []); }).catch(function () {}); }
  useEffect(function () { loadMe(); loadList(); }, []);

  function openDetail(id) { authFetch(API + '/carrier/dispatches/' + id).then(function (r) { return r.json(); }).then(function (d) { if (d && d.success) setDetail(d.dispatch); }).catch(function () {}); }
  function setStatus(id, status) {
    if (!window.confirm('운송 상태를 "' + status + '"(으)로 변경할까요?')) return;
    authFetch(API + '/carrier/dispatches/' + id + '/status', { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ status: status }) })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) { st('상태 변경됨', ''); loadMe(); loadList(); if (detail && detail.id === id) openDetail(id); } else st((d && d.error) || '변경 실패', 'err'); }).catch(function () { st('변경 실패', 'err'); });
  }
  function downloadXlsx(d) {
    authFetch(API + '/carrier/dispatches/' + d.id + '/xlsx').then(function (r) { if (!r.ok) throw new Error('x'); return r.blob(); })
      .then(function (blob) { var url = URL.createObjectURL(blob); var a = document.createElement('a'); a.href = url; a.download = '배차표_' + (d.dispatch_no || '') + '.xlsx'; document.body.appendChild(a); a.click(); a.remove(); setTimeout(function () { try { URL.revokeObjectURL(url); } catch (e) {} }, 1000); })
      .catch(function () { st('엑셀 생성 실패', 'err'); });
  }

  var counts = (me && me.counts) || { 전달: 0, 운송중: 0, 완료: 0 };
  var carrierName = (me && me.carrier && me.carrier.name) || (user && user.name) || '캐리어';
  return (
    <div style={{ padding: 20, maxWidth: 1000, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 16 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: NAVY }}>{'🚚 ' + carrierName}</div>
          <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{'배차 수신 · 운송 처리 포털'}</div>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          {[['전달', '#2563eb'], ['운송중', '#ea580c'], ['완료', '#16a34a']].map(function (k) {
            return <div key={k[0]} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: '8px 16px', textAlign: 'center' }}>
              <div style={{ fontSize: 11, color: '#64748b' }}>{k[0]}</div>
              <div style={{ fontSize: 20, fontWeight: 800, color: k[1] }}>{counts[k[0]] || 0}</div></div>;
          })}
        </div>
      </div>

      <div style={{ overflowX: 'auto', border: '1px solid #e5e7eb', borderRadius: 10, background: '#fff' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead><tr style={{ background: '#f8fafc', color: '#475569' }}>
            <th style={thS}>{'배차번호'}</th><th style={thS}>{'쇼링장'}</th><th style={thS}>{'픽업일'}</th>
            <th style={thC}>{'차량'}</th><th style={thC}>{'상태'}</th><th style={thC}>{'처리'}</th>
          </tr></thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan={6} style={{ padding: 30, textAlign: 'center', color: '#94a3b8' }}>{'배차된 운송 건이 없습니다'}</td></tr>}
            {list.map(function (d) {
              return (
                <tr key={d.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                  <td style={Object.assign({ fontWeight: 700, color: NAVY }, tdS)}>{d.dispatch_no}</td>
                  <td style={tdS}>{d.shoring_yard || '-'}</td>
                  <td style={tdS}>{d.pickup_date || '-'}</td>
                  <td style={tdC}>{d.carCount}</td>
                  <td style={tdC}><span style={{ fontSize: 11, fontWeight: 700, color: '#fff', background: ST_COLOR[d.status] || '#94a3b8', borderRadius: 10, padding: '2px 8px' }}>{d.status}</span></td>
                  <td style={tdC}>
                    <button onClick={function () { openDetail(d.id); }} style={btnGray}>{'상세'}</button>
                    {d.status === '전달' && <button onClick={function () { setStatus(d.id, '운송중'); }} style={Object.assign({}, btnGray, { color: '#c2410c', borderColor: '#fed7aa', background: '#fff7ed' })}>{'운송 시작'}</button>}
                    {d.status === '운송중' && <button onClick={function () { setStatus(d.id, '완료'); }} style={Object.assign({}, btnGray, { color: '#15803d', borderColor: '#bbf7d0', background: '#f0fdf4' })}>{'운송 완료'}</button>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {detail && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }} onClick={function () { setDetail(null); }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 20, width: 580, maxWidth: '94vw', maxHeight: '85vh', display: 'flex', flexDirection: 'column' }} onClick={function (e) { e.stopPropagation(); }}>
            <div style={{ fontSize: 16, fontWeight: 800, color: NAVY }}>{'배차 ' + detail.dispatch_no}</div>
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 10 }}>{'쇼링장: ' + (detail.shoring_yard || '-') + ' · 픽업: ' + (detail.pickup_date || '-') + ' · 상태: ' + detail.status}</div>
            <div style={{ display: 'flex', gap: 6, marginBottom: 10, flexWrap: 'wrap' }}>
              <button onClick={function () { downloadXlsx(detail); }} style={{ padding: '5px 14px', borderRadius: 8, border: '1px solid #bbf7d0', background: '#f0fdf4', color: '#15803d', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>{'📋 배차표 엑셀'}</button>
              {detail.status === '전달' && <button onClick={function () { setStatus(detail.id, '운송중'); }} style={{ padding: '5px 14px', borderRadius: 8, border: 'none', background: '#ea580c', color: '#fff', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>{'운송 시작'}</button>}
              {detail.status === '운송중' && <button onClick={function () { setStatus(detail.id, '완료'); }} style={{ padding: '5px 14px', borderRadius: 8, border: 'none', background: '#16a34a', color: '#fff', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>{'운송 완료'}</button>}
            </div>
            <div style={{ flex: 1, overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: 8 }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead><tr style={{ background: '#f8fafc' }}><th style={thS}>{'#'}</th><th style={thS}>{'차량'}</th><th style={thS}>{'차종'}</th><th style={thS}>{'픽업 주소'}</th></tr></thead>
                <tbody>
                  {(detail.items || []).map(function (it) {
                    return <tr key={it.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                      <td style={tdS}>{it.seq}</td><td style={Object.assign({ fontWeight: 600 }, tdS)}>{it.carNo}</td>
                      <td style={tdS}>{it.carType}</td><td style={tdS}>{it.pickup_address || '-'}</td></tr>;
                  })}
                </tbody>
              </table>
            </div>
            <button onClick={function () { setDetail(null); }} style={{ marginTop: 10, padding: '8px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{'닫기'}</button>
          </div>
        </div>
      )}
    </div>
  );
}

var thS = { padding: '10px 12px', textAlign: 'left', fontWeight: 700, fontSize: 12 };
var thC = Object.assign({}, thS, { textAlign: 'center' });
var tdS = { padding: '9px 12px', color: '#334155' };
var tdC = Object.assign({}, tdS, { textAlign: 'center' });
var btnGray = { marginRight: 4, padding: '3px 10px', border: '1px solid #cbd5e1', background: '#f8fafc', color: '#475569', borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer' };

export default CarrierPortal;
